import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow } from "vue";
const _hoisted_1 = { class: "card-title d-flex align-items-center" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-table-30px" }, null, -1);
const _hoisted_3 = { class: "m-0" };
const _hoisted_4 = {
    key: 0,
    class: "el-table__column"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-14px" }, null, -1);
const _hoisted_7 = {
    key: 1,
    class: "el-table__column"
};
const _hoisted_8 = {
    key: 0,
    class: "el-table__column"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-14px" }, null, -1);
const _hoisted_11 = {
    key: 1,
    class: "el-table__column"
};
import TableOptions from '@/features/SalesReportNew/components/Table/components/Options/TableOptions.vue';
import EditColumns from '@/features/SalesReportNew/components/Table/components/EditColumns/EditColumns.vue';
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
import InfoCard from '@/components/_atoms/InfoCard.vue';
import ListPagination from '@/components/_atoms/ListPagination.vue';
// libs
import { useStore } from 'vuex';
import { ref, watch, computed } from 'vue';
import i18n from '@/i18n';
// utils
import useTableMixin from '@/utilities/mixins/useTableMixin';
import { useMixpanelSortedColumn } from '@/utilities/mixpanel';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SalesReportNewTable',
    setup(__props) {
        // components
        const { getCheckThreshold, useGetValue } = useTableMixin();
        const store = useStore();
        // state
        const tableFiltered = ref([]);
        const searchTerm = ref({});
        const noMask = ref({
            mask: '*'.repeat(255),
            tokens: {
                '*': { pattern: /./ },
            },
        });
        const columnsFiltered = ref([]);
        const sort = ref({
            prop: '',
            order: '',
            orderBy: '',
        });
        // actions
        const fetchTable = () => store.dispatch('salesReportNew/setFetchTable');
        const setIsTableExpanded = (isExpanded) => store.dispatch('salesReportNew/setIsTableExpanded', isExpanded);
        const updateOrderBy = (orderBy) => store.dispatch('salesReportNew/setOrderBy', orderBy);
        const setQuery = ({ column, value }) => store.dispatch('salesReportNew/setQuery', { column, value });
        const clearQuery = (column) => store.dispatch('salesReportNew/setClearSearch', column);
        // computed
        const getHasErrorTable = computed(() => store.getters['salesReportNew/getHasError']);
        const getIsEmptyTable = computed(() => store.getters['salesReportNew/getIsEmpty']);
        const getTableHeader = computed(() => store.getters['salesReportNew/getTableHeader']);
        const getTableBody = computed(() => store.getters['salesReportNew/getTableBody']);
        const getTableSummaryRow = computed(() => store.getters['salesReportNew/getTableSummaryRow']);
        const getIsTableLoading = computed(() => store.getters['salesReportNew/getIsLoading']);
        const getColumnsToSearch = computed(() => {
            return {
                noLabel: getTableHeader.value.filter(column => !column.isMetric).map(c => c.key),
                withLabel: getTableHeader.value.filter(column => !column.isMetric).map(c => ({ key: c.key, label: c.name })),
            };
        });
        const getIsTableExpanded = computed(() => store.getters['salesReportNew/getIsTableExpanded']);
        const getPreset = computed(() => store.getters['salesReportNew/getPreset']);
        const pagination = computed(() => store.getters['salesReportNew/getPagination']);
        const limitRange = computed(() => store.getters['salesReportNew/getLimitRange']);
        const getDatepickerDates = computed(() => store.getters['dates']);
        const getOrderBy = computed(() => store.getters['salesReportNew/getOrderBy']);
        // functions
        const tableRowClassName = ({ row, column, columnIndex }) => {
            const threshold = getTableHeader.value[columnIndex]['threshold'];
            const isMetricOrDimension = getTableHeader.value[columnIndex]['isMetric'] ? 'metric' : 'dimension';
            const cellsToPaint = ['CONVERTION_RATE', 'REVENUE_PER_CONTACT_EXPERT', 'CONVERTION_RATE_EXPERT'];
            const newClass = `threshold ${isMetricOrDimension} ${getCheckThreshold({
                amount: row[column.property],
                threshold,
            })}`;
            if (cellsToPaint.includes(column.property)) {
                return `${newClass}`;
            }
            return newClass;
        };
        const tableHeaderClassName = ({ columnIndex }) => {
            const isMetric = getTableHeader.value[columnIndex]['isMetric'] ? 'metric' : 'dimension';
            return isMetric;
        };
        const formatter = (row, column) => {
            const typeColumn = getColumnType(column.property);
            return useGetValue({ type: typeColumn, amount: row[column.property] });
        };
        const getColumnType = (property) => {
            return getTableHeader.value.find((col) => col.key === property)?.type || '';
        };
        const getLabel = (key) => {
            return getColumnsToSearch.value.withLabel.filter(column => column.key === key)[0]['label'];
        };
        const getPlaceholder = (column) => {
            return column === 'SUGGESTION_DATE' ? '2000-12-31' : 'Busque nesta coluna';
        };
        const getMask = (column) => {
            return column === 'SUGGESTION_DATE' ? '####-##-##' : noMask.value;
        };
        const orderTable = ({ prop, order }) => {
            useMixpanelSortedColumn('view_oto_sales_report_new_sort-column', prop, order);
            const sortItem = order === 'descending' ? `-${prop}` : prop;
            const appliedSortItem = !order ? '' : sortItem;
            sort.value.orderBy = !order ? '' : sortItem;
            sort.value.prop = prop;
            sort.value.order = order;
            updateOrderBy(appliedSortItem);
            fetchTable();
        };
        const getFormattedSummaryRow = ({ columns }) => {
            const summaryRow = getTableSummaryRow.value;
            const totalText = i18n.global.t('_total');
            const loadingText = i18n.global.t('_loading-dots');
            const generateRow = (fillText) => [totalText, ...new Array(columns.length).fill(fillText)];
            if (!summaryRow)
                return getIsTableLoading.value ? generateRow('-') : generateRow(loadingText);
            return columns.map((column, index) => (index === 0 ? totalText : formatter(summaryRow, column)));
        };
        const searchByColumn = (column, value) => {
            columnsFiltered.value = [...columnsFiltered.value, column];
            const result = value;
            setQuery({ column, value: result });
            fetchTable();
        };
        const clearSearch = (column) => {
            searchTerm.value[column] = '';
            columnsFiltered.value = columnsFiltered.value.filter(col => col !== column);
            clearQuery(column);
            fetchTable();
        };
        watch(() => getTableBody.value, newValue => {
            tableFiltered.value = newValue;
        });
        watch(() => getPreset.value, () => {
            columnsFiltered.value = [];
            searchTerm.value = {};
        });
        watch(() => getDatepickerDates, () => {
            fetchTable();
        }, { deep: true });
        watch(() => getOrderBy.value, () => {
            if (!getOrderBy.value) {
                sort.value.orderBy = '';
                sort.value.prop = '';
                sort.value.order = '';
            }
        });
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_table_column = _resolveComponent("el-table-column");
            const _component_el_table = _resolveComponent("el-table");
            const _component_el_dialog = _resolveComponent("el-dialog");
            const _component_base_card_header = _resolveComponent("base-card-header");
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            const _directive_mask = _resolveDirective("mask");
            return (_openBlock(), _createBlock(_component_base_card_v2, { class: "card sales-report-new-table" }, {
                default: _withCtx(() => [
                    _createVNode(_component_el_dialog, {
                        class: "dialog-metrics",
                        modelValue: getIsTableExpanded.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((getIsTableExpanded).value = $event)),
                        fullscreen: "",
                        height: "70vh",
                        width: "100%",
                        onClose: _cache[1] || (_cache[1] = ($event) => (setIsTableExpanded(false)))
                    }, {
                        title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _hoisted_2,
                                _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('metrics')), 1)
                            ]),
                            _createElementVNode("div", null, [
                                _createElementVNode("div", null, [
                                    _createVNode(TableOptions, { "has-expanded-table": false }),
                                    (!getIsTableLoading.value && !getHasErrorTable.value)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (!getIsTableLoading.value)
                                                ? (_openBlock(), _createBlock(_component_el_table, {
                                                    key: 0,
                                                    data: tableFiltered.value,
                                                    "show-summary": "",
                                                    "summary-method": getFormattedSummaryRow,
                                                    style: { "width": "100%" },
                                                    stripe: "",
                                                    "scrollbar-always-on": true,
                                                    "cell-class-name": tableRowClassName,
                                                    "header-cell-class-name": tableHeaderClassName,
                                                    "default-sort": sort.value,
                                                    onSortChange: orderTable
                                                }, {
                                                    default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTableHeader.value, (column, index) => {
                                                            return (_openBlock(), _createBlock(_component_el_table_column, {
                                                                key: index,
                                                                formatter: formatter,
                                                                sortable: "custom",
                                                                fixed: index === 0 ?? true,
                                                                prop: column.key,
                                                                label: column.name,
                                                                "min-width": 200
                                                            }, {
                                                                header: _withCtx(() => [
                                                                    (!getColumnsToSearch.value.noLabel.includes(column.key))
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                                            _createElementVNode("label", null, _toDisplayString(column.name), 1),
                                                                            (column.tooltip)
                                                                                ? (_openBlock(), _createBlock(_component_el_popover, {
                                                                                    key: 0,
                                                                                    trigger: "hover",
                                                                                    placement: "top",
                                                                                    width: 180
                                                                                }, {
                                                                                    reference: _withCtx(() => [
                                                                                        _hoisted_6
                                                                                    ]),
                                                                                    default: _withCtx(() => [
                                                                                        _createElementVNode("p", {
                                                                                            innerHTML: column.tooltip
                                                                                        }, null, 8, _hoisted_5)
                                                                                    ]),
                                                                                    _: 2
                                                                                }, 1024))
                                                                                : _createCommentVNode("", true)
                                                                        ]))
                                                                        : _createCommentVNode("", true),
                                                                    (getColumnsToSearch.value.noLabel.includes(column.key))
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                                            _createElementVNode("label", null, _toDisplayString(getLabel(column.key)), 1),
                                                                            _createVNode(_component_el_popover, {
                                                                                trigger: "hover",
                                                                                placement: "bottom",
                                                                                width: 260
                                                                            }, {
                                                                                reference: _withCtx(() => [
                                                                                    _createElementVNode("i", {
                                                                                        class: _normalizeClass([{ 'color-oto-brand-omni': columnsFiltered.value.includes(column.key) }, "icon icon-search-12px ml--4"])
                                                                                    }, null, 2)
                                                                                ]),
                                                                                default: _withCtx(() => [
                                                                                    _withDirectives(_createVNode(_component_el_input, {
                                                                                        modelValue: searchTerm.value[column.key],
                                                                                        "onUpdate:modelValue": ($event) => ((searchTerm.value[column.key]) = $event),
                                                                                        size: "small",
                                                                                        placeholder: getPlaceholder(column.key),
                                                                                        onKeyup: _withKeys(($event) => (searchByColumn(column.key, searchTerm.value[column.key])), ["enter"])
                                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onKeyup"]), [
                                                                                        [_directive_mask, getMask(column.key)]
                                                                                    ]),
                                                                                    _createElementVNode("div", null, [
                                                                                        _createVNode(_component_el_button, {
                                                                                            disabled: !searchTerm.value[column.key],
                                                                                            round: "",
                                                                                            size: "small",
                                                                                            text: "",
                                                                                            onClick: ($event) => (clearSearch(column.key))
                                                                                        }, {
                                                                                            default: _withCtx(() => [
                                                                                                _createTextVNode(_toDisplayString(searchTerm.value[column.key] ? 'limpar filtro' : 'cancelar'), 1)
                                                                                            ]),
                                                                                            _: 2
                                                                                        }, 1032, ["disabled", "onClick"]),
                                                                                        _createVNode(_component_el_button, {
                                                                                            disabled: !searchTerm.value[column.key],
                                                                                            round: "",
                                                                                            size: "small",
                                                                                            type: "primary",
                                                                                            onClick: ($event) => (searchByColumn(column.key, searchTerm.value[column.key]))
                                                                                        }, {
                                                                                            default: _withCtx(() => [
                                                                                                _createTextVNode("pesquisar")
                                                                                            ]),
                                                                                            _: 2
                                                                                        }, 1032, ["disabled", "onClick"])
                                                                                    ])
                                                                                ]),
                                                                                _: 2
                                                                            }, 1024)
                                                                        ]))
                                                                        : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["fixed", "prop", "label"]));
                                                        }), 128))
                                                    ]),
                                                    _: 1
                                                }, 8, ["data", "default-sort"]))
                                                : _createCommentVNode("", true),
                                            _withDirectives(_createVNode(InfoCard, { error: getHasErrorTable.value }, null, 8, ["error"]), [
                                                [_vShow, !getIsTableLoading.value && getIsEmptyTable.value]
                                            ])
                                        ], 64))
                                        : _createCommentVNode("", true),
                                    _withDirectives(_createVNode(BaseLoader, null, null, 512), [
                                        [_vShow, getIsTableLoading.value]
                                    ]),
                                    _withDirectives(_createVNode(InfoCard, { error: getHasErrorTable.value }, null, 8, ["error"]), [
                                        [_vShow, !getIsTableLoading.value && getHasErrorTable.value]
                                    ]),
                                    (!getIsTableLoading.value && !getHasErrorTable.value)
                                        ? (_openBlock(), _createBlock(ListPagination, {
                                            key: 1,
                                            data: pagination.value,
                                            limit: pagination.value.limit,
                                            "limit-range": limitRange.value,
                                            identify: "sales-report-new",
                                            onChangePage: fetchTable
                                        }, null, 8, ["data", "limit", "limit-range"]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]),
                        _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_base_card_header, {
                        title: _ctx.$t('360.metrics'),
                        icon: "icon-table-30px"
                    }, null, 8, ["title"]),
                    _createVNode(TableOptions, { "has-expanded-table": true }),
                    (!getIsTableLoading.value && !getHasErrorTable.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (!getIsTableLoading.value)
                                ? (_openBlock(), _createBlock(_component_el_table, {
                                    key: 0,
                                    data: tableFiltered.value,
                                    "show-summary": "",
                                    "summary-method": getFormattedSummaryRow,
                                    style: { "width": "100%" },
                                    stripe: "",
                                    "scrollbar-always-on": true,
                                    "cell-class-name": tableRowClassName,
                                    "header-cell-class-name": tableHeaderClassName,
                                    "default-sort": sort.value,
                                    onSortChange: orderTable
                                }, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTableHeader.value, (column, index) => {
                                            return (_openBlock(), _createBlock(_component_el_table_column, {
                                                key: index,
                                                formatter: formatter,
                                                sortable: "custom",
                                                fixed: index === 0 ?? true,
                                                prop: column.key,
                                                label: column.name,
                                                "min-width": 180
                                            }, {
                                                header: _withCtx(() => [
                                                    (!getColumnsToSearch.value.noLabel.includes(column.key))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                            _createElementVNode("label", null, _toDisplayString(column.name), 1),
                                                            (column.tooltip)
                                                                ? (_openBlock(), _createBlock(_component_el_popover, {
                                                                    key: 0,
                                                                    trigger: "hover",
                                                                    placement: "top",
                                                                    width: 180
                                                                }, {
                                                                    reference: _withCtx(() => [
                                                                        _hoisted_10
                                                                    ]),
                                                                    default: _withCtx(() => [
                                                                        _createElementVNode("p", {
                                                                            innerHTML: column.tooltip
                                                                        }, null, 8, _hoisted_9)
                                                                    ]),
                                                                    _: 2
                                                                }, 1024))
                                                                : _createCommentVNode("", true)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (getColumnsToSearch.value.noLabel.includes(column.key))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                            _createElementVNode("label", null, _toDisplayString(getLabel(column.key)), 1),
                                                            _createVNode(_component_el_popover, {
                                                                trigger: "hover",
                                                                placement: "bottom",
                                                                width: 260
                                                            }, {
                                                                reference: _withCtx(() => [
                                                                    _createElementVNode("i", {
                                                                        class: _normalizeClass([{ 'color-oto-brand-omni': columnsFiltered.value.includes(column.key) }, "icon icon-search-12px ml--4"])
                                                                    }, null, 2)
                                                                ]),
                                                                default: _withCtx(() => [
                                                                    _withDirectives(_createVNode(_component_el_input, {
                                                                        modelValue: searchTerm.value[column.key],
                                                                        "onUpdate:modelValue": ($event) => ((searchTerm.value[column.key]) = $event),
                                                                        size: "small",
                                                                        placeholder: getPlaceholder(column.key),
                                                                        onKeyup: _withKeys(($event) => (searchByColumn(column.key, searchTerm.value[column.key])), ["enter"])
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onKeyup"]), [
                                                                        [_directive_mask, getMask(column.key)]
                                                                    ]),
                                                                    _createElementVNode("div", null, [
                                                                        _createVNode(_component_el_button, {
                                                                            disabled: !searchTerm.value[column.key],
                                                                            round: "",
                                                                            size: "small",
                                                                            text: "",
                                                                            onClick: ($event) => (clearSearch(column.key))
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(searchTerm.value[column.key] ? 'limpar filtro' : 'cancelar'), 1)
                                                                            ]),
                                                                            _: 2
                                                                        }, 1032, ["disabled", "onClick"]),
                                                                        _createVNode(_component_el_button, {
                                                                            disabled: !searchTerm.value[column.key],
                                                                            round: "",
                                                                            size: "small",
                                                                            type: "primary",
                                                                            onClick: ($event) => (searchByColumn(column.key, searchTerm.value[column.key]))
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _createTextVNode("pesquisar")
                                                                            ]),
                                                                            _: 2
                                                                        }, 1032, ["disabled", "onClick"])
                                                                    ])
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                            }, 1032, ["fixed", "prop", "label"]));
                                        }), 128))
                                    ]),
                                    _: 1
                                }, 8, ["data", "default-sort"]))
                                : _createCommentVNode("", true),
                            _withDirectives(_createVNode(InfoCard, { error: getHasErrorTable.value }, null, 8, ["error"]), [
                                [_vShow, !getIsTableLoading.value && getIsEmptyTable.value]
                            ])
                        ], 64))
                        : _createCommentVNode("", true),
                    _withDirectives(_createVNode(BaseLoader, null, null, 512), [
                        [_vShow, getIsTableLoading.value]
                    ]),
                    _withDirectives(_createVNode(InfoCard, { error: getHasErrorTable.value }, null, 8, ["error"]), [
                        [_vShow, !getIsTableLoading.value && getHasErrorTable.value]
                    ]),
                    _createVNode(EditColumns),
                    (!getIsTableLoading.value && !getHasErrorTable.value)
                        ? (_openBlock(), _createBlock(ListPagination, {
                            key: 1,
                            data: pagination.value,
                            limit: pagination.value.limit,
                            "limit-range": limitRange.value,
                            identify: "sales-report-new",
                            onChangePage: fetchTable,
                            "show-list-pages": false,
                            "show-quantity-lines": true
                        }, null, 8, ["data", "limit", "limit-range"]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
